import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable, Subscription } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { UserSessionService } from './services/user-session.service';
import AppRoutes, { getRouteParts } from './app-routes';
import { ApiService } from './services/api.service';
import Line from 'src/models/line';
import { MatDialog } from '@angular/material/dialog';
import { LinePickerComponent } from './common/line-picker/line-picker.component';
import { LiveUpdateService } from './services/live-update.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );
  groupedRoutes = [
    {
      name: 'Changeover', routes: [
        { name: 'Current', icon: 'timer', matchExact: true, disabled: false, routeParts: ['/', ...getRouteParts(AppRoutes.Changeover)] },
        { name: 'Review', icon: 'assessment', matchExact: true, disabled: false, routeParts: ['/', ...getRouteParts(AppRoutes.ChangeoverReview)] },
        { name: 'Schedule', icon: 'edit_calendar', matchExact: false, disabled: false, routeParts: ['/', ...getRouteParts(AppRoutes.LineSchedule)] },
      ]
    },
    {
      name: 'Factory', routes: [
        { name: 'Line Setup', icon: 'upload', matchExact: false, disabled: false, routeParts: ['/', ...getRouteParts(AppRoutes.LineSetup)] },
      ]
    }
  ];
  subscriptions = new Array<Subscription>();

  line: Line | null = null;
  liveUpdatesAvailable: boolean | null = null;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private readonly apiService: ApiService,
    private readonly liveUpdateService: LiveUpdateService,
    public readonly userSessionService: UserSessionService,
    public readonly dialog: MatDialog
  ) {
  }

  ngOnInit(): void {
    this.userSessionService.init();
    this.subscriptions.push(
      this.liveUpdateService.IsConnectedChanged.subscribe(isConnected => this.liveUpdatesAvailable = isConnected),
      this.userSessionService.isLoggedInChanged.subscribe(this.loadData),
      this.userSessionService.activeLineIdChanged.subscribe(lineId => this.loadData(this.userSessionService.isLoggedIn)),
    );
  }

  loadData = async (isLoggedIn: boolean) => {
    if (isLoggedIn) {
      this.line = await this.apiService.getLine(this.userSessionService.activeLineId);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.userSessionService.destroy();
  }

  openLinePicker = () => {
    const handle = LinePickerComponent.Open(this.dialog, this.userSessionService.activeLineId);
    handle.afterClosed().subscribe(selectedLine => {
      if (selectedLine) {
        this.userSessionService.activeLineId = selectedLine.id;
      }
    });
  }

  forceReload() {
    location.reload();
  }
}
